export var MemberRole;
(function (MemberRole) {
    // users
    MemberRole["OWNER"] = "owner";
    MemberRole["ADMIN"] = "admin";
    MemberRole["FILESPACE_ADMIN"] = "filespaceAdmin";
    MemberRole["COLLABORATOR"] = "collaborator";
    MemberRole["GUEST"] = "guest";
    // service accounts
    MemberRole["SERVICE_ADMIN"] = "serviceAdmin";
    MemberRole["SERVICE_COLLABORATOR"] = "serviceCollaborator";
})(MemberRole || (MemberRole = {}));
export const ServiceAccountMemberRole = {
    SERVICE_ADMIN: MemberRole.SERVICE_ADMIN,
    SERVICE_COLLABORATOR: MemberRole.SERVICE_COLLABORATOR,
};
export const SERVICE_ACCOUNT_MEMBER_ROLES = [
    MemberRole.SERVICE_ADMIN,
    MemberRole.SERVICE_COLLABORATOR,
];
